import playerStyle from "./Player.module.scss";
import foxbelIcon from '../../../assets/images/logo.png';
import { useAudio } from "../../../hooks/useAudio";
import { useEffect, useState } from "react";
import { VolumeController } from "./VolumeController/VolumeController";

type PlayerProps = {
    trackList: any,
    albumTitle: string,
    cover: string
}

type currentTrackType = {
    artistName: string,
    title: string,
    preview: string,
}

const currentTrackInitial = {
    artistName: "",
    title: "",
    preview: ""
}

export const Player = ({ albumTitle, cover, trackList }: PlayerProps) => {
    const { playing, ended, toggle, changeTrack, changeVolume, trackURL } = useAudio("");
    const [currentTrack, setCurrentTrack] = useState<currentTrackType>(currentTrackInitial);
    const [trackIndex, setTrackIndex] = useState<number>(0);

    useEffect(() => {
        if (trackList.length < 1) return;
        if (playing) toggle();
        setCurrentTrack({
            artistName: trackList[0].artist.name,
            title: trackList[0].title,
            preview: trackList[0].preview
        });
        setTrackIndex(0);
    }, [trackList])

    useEffect(() => {
        if (currentTrack.preview === "") return;
        changeTrack(currentTrack.preview);
    }, [currentTrack])

    useEffect(() => {
        if (!ended) return;
        const newTrackIdx = trackIndex + 1;
        if (!trackList[newTrackIdx]) return;
        setCurrentTrack({
            artistName: trackList[newTrackIdx].artist.name,
            title: trackList[newTrackIdx].title,
            preview: trackList[newTrackIdx].preview
        })
        setTrackIndex(newTrackIdx);
    }, [ended])

    const stepForward = () => {
        const newTrackIdx = trackIndex + 1;
        if (!trackList[newTrackIdx]) return;
        toggle();
        setCurrentTrack({
            artistName: trackList[newTrackIdx].artist.name,
            title: trackList[newTrackIdx].title,
            preview: trackList[newTrackIdx].preview
        })
        setTrackIndex(newTrackIdx);
    }

    const stepBackward = () => {
        const newTrackIdx = trackIndex - 1;
        if (!trackList[newTrackIdx]) return;
        toggle();
        setCurrentTrack({
            artistName: trackList[newTrackIdx].artist.name,
            title: trackList[newTrackIdx].title,
            preview: trackList[newTrackIdx].preview
        })
        setTrackIndex(newTrackIdx);
    }

    return (
        <div className={playerStyle.player}>
            <div className={playerStyle.content}>
                <div className={playerStyle.cover}>
                    <img src={cover || foxbelIcon} alt="current-album-cover" />
                </div>
                <div className={playerStyle.info}>
                    <h4>{currentTrack.title !== "" ? currentTrack.title : "Cancion"}</h4>
                    <p>{currentTrack.artistName !== "" ? currentTrack.artistName : "Artista"} - {albumTitle ? albumTitle : "Album"}</p>
                </div>
                <div className={playerStyle.panel}>
                    <div className={`
                        ${playerStyle.button}  
                        ${currentTrack.preview === "" || trackIndex === 0 ? playerStyle.disabled : ""}`}
                        onClick={stepBackward} >
                        <i className="fas fa-step-backward"></i>
                    </div>
                    <div
                        className={`
                            ${playerStyle.mainButton} 
                            ${playerStyle.button} 
                            ${currentTrack.preview !== "" ? "" : playerStyle.disabled}`}
                        onClick={toggle as (() => void)} >
                        {playing ?
                            <i className="fas fa-pause"></i>
                            :
                            <i className="fas fa-play"></i>
                        }
                    </div>
                    <div className={`
                        ${playerStyle.button}  
                        ${currentTrack.preview === "" || trackIndex + 1 >= trackList.length ? playerStyle.disabled : ""}`}
                        onClick={stepForward} >
                        <i className="fas fa-step-forward"></i>
                    </div>
                </div>
                <VolumeController currentTrack={trackURL} changeVolume={changeVolume} className={playerStyle.volume} />
            </div>
        </div>
    )
}